import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { GetAllCseResponse } from "@/core/types/(api)/cse";
import { MEDIUM_LIVED_CACHE } from "@/lib/constants/cache";

import { customerSuccessKeys } from "../keyFactory";
import { getCseList } from "../queryFunctions/getCseList";

type UseCseListProps<TData = GetAllCseResponse> = {
  enabled?: boolean;
  select?: (data: GetAllCseResponse) => TData;
};

type CseListQueryOptions = UseQueryOptions<
  GetAllCseResponse,
  unknown,
  GetAllCseResponse,
  ReturnType<typeof customerSuccessKeys.cseList>
>;

export function useCseList<TData = GetAllCseResponse>({
  enabled = true,
  select,
}: UseCseListProps<TData> = {}) {
  return useQuery({ ...optionFactory(enabled), select });
}

function optionFactory(enabled: boolean) {
  return {
    enabled,
    queryFn: getCseList,
    queryKey: customerSuccessKeys.cseList(),
    staleTime: MEDIUM_LIVED_CACHE,
  } satisfies CseListQueryOptions;
}
